import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-collapsed-card',
  templateUrl: './collapsed-card.component.html',
  styleUrl: './collapsed-card.component.scss'
})
export class CollapsedCardComponent {
  @Input({ required: true }) title: string;
  @Input() isCollapsed = false;

  @Output() toggle = new EventEmitter<boolean>();

}
